import ReactEChartsCore from 'echarts-for-react/lib/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import type { EChartsOption } from 'echarts';
import {
  breakpointsMediaQuery,
  getColor,
  tooltipFormatter,
  useMediaQuery
} from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { useRef } from 'react';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import { serpTooltips } from '@/app/Serp/tooltip/serpTooltips';
import { useTooltipHide } from '@/hooks/useTooltipHide';
echarts.use([LineChart, TooltipComponent, GridComponent, LegendComponent]);

interface CharacteristicDistributionOfTechsProps {
  data?: {
    categories?: string[];
    values?: number[];
  };
}

// نمودار توزیع تکنولوژی ها
const CharacteristicDistributionOfTechs = ({
  data
}: CharacteristicDistributionOfTechsProps) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  const formattedBar = data?.categories?.map(row => row);
  const formattedData = data?.values?.map(row => row);

  // تنظیمات نمودار
  const getOption = (): EChartsOption => ({
    textStyle: {
      fontFamily: 'dana'
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: tooltipFormatter as any,
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor('gray-800'),
        formatter: (value: number) => String(value),
        margin: 15
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      data: formattedBar?.reverse(),
      type: 'category',
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 10
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisTick: { show: false },
      axisLine: { show: false }
    },
    series: [
      {
        type: 'bar',
        name: 'تعداد',
        data: formattedData?.reverse(),
        lineStyle: {
          color: getColor('navbar-vertical-default-link-active-color')
        },
        itemStyle: {
          color: getColor('navbar-vertical-default-link-active-color'),
          borderRadius: [0, 3, 3, 0]
        },
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true,
          itemStyle: {
            color: getColor('navbar-vertical-default-link-active-color')
          },
          lineStyle: {
            color: getColor('navbar-vertical-default-link-active-color')
          }
        }
      }
    ],
    grid: { right: '3%', left: '130px', bottom: '10%', top: '5%' }
  }) as EChartsOption;

  return (
    <Card className="mb-3 h-100" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            توزیع تکنولوژی سایت‌ها{' '}
            <HelpTooltip html={serpTooltips.distributionOfTech} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="px-3 text-center">
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getOption()}
          style={{ height: '14.9rem' }}
        />
      </Card.Body>
      <Card.Footer className="bg-body-tertiary text-center fs--1">
        اکثر سایت ها از تکنولوژی های{' '}
        <b>{data?.categories?.slice(0, 3).join(' و ')}</b>
        &nbsp; استفاده میکنند.
      </Card.Footer>
    </Card>
  );
};
export default CharacteristicDistributionOfTechs;
